import { FeatureFlags } from '@fabric-ui/components';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { serializeSortItem } from '@utils/utils';
import { PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/connected-products/')({
  validateSearch: zodValidator(
    withDefaults(schema.CONNECTED_PRODUCTS, { orderBy: [serializeSortItem({ property: 'productName', isAsc: true })] })
  ),
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.featureFlags[FeatureFlags.ConnectedProductsFrontend] &&
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CONNECTED_PRODUCTS });
    context.validatePermissions({ isAllowed, preload });
  },
});
